import { useMemo } from 'react';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType } from 'components/list/DynamicListFilterUtils';

import { ADVANCE_WMS_MODULE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

/**
 * @author Burak Ak
 * @description Stock Update Report Page only for Saif Gallery
 */

const StockUpdate = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'ID', accessor: 'ID', filterType: FilterType.number, show: false, width: 10 },
			{ Header: 'sku', accessor: 'sku', filterType: FilterType.string, width: 30 },
			{ Header: 'updateQuantity', accessor: 'updateQuantity', filterType: FilterType.number, width: 30 }
		],
		[]
	);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="stockUpdateReports"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.OTO_PACK_REPORTS)}
				/>
			</HeaderContainerFormHeader>

			<DynamicList
				id={DYNAMICLISTS.STOCK_UPDATE}
				defaultSort={defaultSort}
				columns={columns}
				fetchUrl={ADVANCE_WMS_MODULE.GET_STOCK_UPDATE_LIST}
				exportName="stockUpdate"
			/>
		</div>
	);
};

export default StockUpdate;
